import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'

import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import i18n from 'modules/core/lib/i18n'

import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'
import FileList from 'modules/documents/components/FileList'

interface Props {
  onFileAdded: (file: File[], step: string) => void
  onFileRemoved: (indexToRemove: number, step: string) => void
  documents: File[] | null
  stepIdentifier: string
  label: string
}

const UploadFile = ({ onFileAdded, documents, stepIdentifier, label, onFileRemoved }: Props) => {
  const onDrop = (files: File[]) => {
    onFileAdded(files, stepIdentifier)
  }

  const onRemoveFile = (indexToRemove: number) => {
    onFileRemoved(indexToRemove, stepIdentifier)
  }

  return (
    <Box gap="s6">
      <Text.Normal size="200" weight="medium">
        {label}
      </Text.Normal>
      <DropzoneBox
        onDrop={onDrop}
        icon={clouds}
        message={i18n.t('documents.drop_here')}
        accept={acceptedContentTypes()}
      />
      {!!documents && <FileList files={documents} onDeleteFile={onRemoveFile} />}
    </Box>
  )
}

export default UploadFile
